import { State } from 'shared/interface';
import { DictionaryRecordType } from '../interface';
import { NAMESPACE } from './interface';

export const createDictionarySelector = (state: State) => {
	return (recordType: DictionaryRecordType, ids: number[]) => {
		const dictionary = state[NAMESPACE][recordType];
		return ids.map((id) => dictionary[id] || id);
	};
};
